const img1 = require("../images/slider/slide_1.png").default
const img2 = require("../images/slider/slide_2.png").default
const img3 = require("../images/slider/slide_3.png").default

const heroSliderData = [
    {
        title: "Polo nữ Pima cao cấp",
        description: "Nhắc đến sự đẳng cấp là không thể không nhắc đến dòng vải pima. Nó tạo nên chất lượng tốt nhất cho bất kỳ sản phẩm thời trang nào. Sợi vải pima dài và dày hơn sợi cotton thông thường gấp đôi nhờ công nghệ dệt tân tiến. Điều đó làm cho kết cấu áo polo chắc chắn, bền chặt, hạn chế tối đa xù lông, mềm mượt, bền màu, vô cùng đảm bảo sức khoẻ người dùng",
        img: img1,
        color: "blue",
        path: "/catalog/ao-thun-dinosaur-01"
    },
    {
        title: "Polo Nữ Dáng Suông Modal",
        description: "Polo nữ dáng suông Modal sử dụng công nghệ vải cao cấp thân thiện với môi trường sản xuất độc quyền chống co rút vải, áo polo nữ vải modal là sản phẩm thích hợp cho các bạn có môi trường làm việc năng động như hiện nay",
        img: img2,
        path: "/catalog/ao-thun-dinosaur-02",
        color: "pink"
    },
    {
        title: "Polo Nữ Coolmax Lacoste",
        description: "Mẫu áo polo nữ được làm bằng chất liệu coolmax đem lại cảm giác mát lạnh khi mặc. Thiết kế mẫu áo polo coolmax này có kiểu dáng cực kỳ thoải mái. Tạo sự gọn gàng hứa hẹn sẽ là mẫu áo polo vô cùng hot trong thời điểm sắp tới",
        img: img3,
        path: "/catalog/ao-thun-dinosaur-03",
        color: "orange"
    }
]

export default heroSliderData